import moment from 'moment';
export default function isDate12HoursBefore(value) {
    return moment(value, 'DD.MM.YYYY', true).isAfter(moment().subtract(12, 'hours'));
}
